import { NavigationModes } from './navigationModes';
export const defaultSettings = {
    duration: 1000,
    slideTransition: 'ease',
    mode: NavigationModes.CENTER,
    loop: false,
    isRTL: false,
};
//# sourceMappingURL=defaultNavigationSettings.js.map